module.exports = __webpack_public_path__ + "static/img/goodsList_loading_duiduoduo.41da03a5.png";